import React from "react";
import "./CardLayout.css";

const CardLayout = ({ children, style, className = "" }) => {
  return (
    <div style={style} className={`cardLayout ${className}`}>
      {children}
    </div>
  );
};

export default CardLayout;
